// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(min-width: 1024px)";
var _3 = "wrapper-2Bjsj";
var _4 = "timelimit-29q3p";
export { _1 as "__esModule", _2 as "desktop_only", _3 as "wrapper", _4 as "timelimit" }
export default { "__esModule": _1, "desktop_only": _2, "wrapper": _3, "timelimit": _4 }
